import { AppFeature, TextFeature } from '../types';

interface VersionConfig {
  appFeatures: AppFeature[];
  textFeatures: TextFeature[];
  heroSubtitle: string;
  aboutText: string;
}

// Map source parameters to version keys
export const sourceToVersion: Record<string, string> = {
  'paramounts': 'v1',
  'klayvio': 'v1',
  // Add more mappings as needed
};

export const versions: Record<string, VersionConfig> = {
  default: {
    heroSubtitle: "iOS Engineer & Product Manager",
    aboutText: 
      "I'm a product manager by training. Then in 2019, I had an idea for a side project. " +
      "An iPhone app for aspiring chefs. So I taught myself to code. Built the app. " +
      "Launched it in the App Store. And things took off.\n\n" +
      "The app was picked up on Reddit. Then TechCrunch. Featured in the App Store. " +
      "I was reading tutorials one day. Shipping features the next. Designing mockups. Emailing with customers. " +
      "And loving it. \n\n" +
      "I monetized the app, Half Lemons. Shipped two more. And grew my project into a business. " +
      "I found out I had the skills to write good software. And with that, I became a software engineer.",
    appFeatures: [], // Will be populated from Home.tsx
    textFeatures: [], // Will be populated from Home.tsx
  },
  v1: {
    heroSubtitle: "Product Manager who Codes",
    aboutText: "I'm a product manager by training. Then in 2019, I had an idea for a side project" + 
      "— an iPhone app for home chefs like me. So I taught myself to code. Built the app. Launched it in the " +
      "App Store. And it took off.\n\n" +
      "The app was picked up on Reddit. Then TechCrunch. Featured in the App Store. I was " +
      "planning features one day. Coding them the next. Designing mockups. Replying to customers & " +
      "journalists. And loving it.\n\n" +
      "I monetized the app, Half Lemons. Launched two more. And grew my side project " +
      "into a real business. Somewhere along the way, I realized: I wasn’t just " +
      "managing product anymore. I was building it. And that’s when everything clicked.",
    appFeatures: [], // Will be populated from Home.tsx
    textFeatures: [], // Will be populated from Home.tsx
  }
}; 